"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _ReferenceResolverType = _interopRequireDefault(require("reference-resolvers/schema/ReferenceResolverType"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIDropdown = _interopRequireDefault(require("UIComponents/dropdown/UIDropdown"));

var _UIEditableControls = _interopRequireDefault(require("UIComponents/editable/UIEditableControls"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/legacy/UIFormControl"));

var _UIGrid = _interopRequireDefault(require("UIComponents/grid/UIGrid"));

var _UIGridItem = _interopRequireDefault(require("UIComponents/grid/UIGridItem"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _UITag = _interopRequireDefault(require("UIComponents/tag/UITag"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _ContactRecord = _interopRequireDefault(require("customer-data-objects/contact/ContactRecord"));

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _PropertyValidations = require("customer-data-properties/validation/PropertyValidations");

var _PropertyInputEmailWrapper = _interopRequireDefault(require("customer-data-properties/input/PropertyInputEmailWrapper"));

var propTypes = {
  draftEmails: _reactImmutableProptypes.default.map.isRequired,
  onCancel: _react.PropTypes.func.isRequired,
  onChange: _react.PropTypes.func.isRequired,
  onDelete: _react.PropTypes.func.isRequired,
  onSave: _react.PropTypes.func.isRequired,
  promoteToPrimary: _react.PropTypes.func.isRequired,
  propertyInputEmailDefaultProps: _react.PropTypes.object.isRequired,
  resolver: _ReferenceResolverType.default.isRequired,
  subject: _react.PropTypes.instanceOf(_ContactRecord.default),
  value: _react.PropTypes.string.isRequired,
  'data-selenium-test': _react.PropTypes.string
};

var PropertyInputMultipleEmailInput =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(PropertyInputMultipleEmailInput, _PureComponent);

  function PropertyInputMultipleEmailInput(props) {
    var _this;

    (0, _classCallCheck2.default)(this, PropertyInputMultipleEmailInput);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PropertyInputMultipleEmailInput).call(this, props));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.partial = (0, _ComponentMethods.makePartial)();
    _this.state = {
      isInputFocused: false,
      initialValue: props.value,
      duplicateValue: false
    };
    return _this;
  }

  (0, _createClass2.default)(PropertyInputMultipleEmailInput, [{
    key: "getDraftValue",
    value: function getDraftValue(email) {
      var draftEmails = this.props.draftEmails;

      if (draftEmails.has(email)) {
        return draftEmails.getIn([email, 'value']);
      }

      return email;
    }
  }, {
    key: "getIsPrimaryEmail",
    value: function getIsPrimaryEmail() {
      var _this$props = this.props,
          draftEmails = _this$props.draftEmails,
          value = _this$props.value;
      return draftEmails.get(value).get('isPrimary');
    }
  }, {
    key: "handleOpenChange",
    value: function handleOpenChange(_ref) {
      var value = _ref.target.value;
      this.setState({
        isInputFocused: value
      });
    }
  }, {
    key: "handleInvalidProperty",
    value: function handleInvalidProperty(duplicateValue) {
      this.setState({
        duplicateValue: duplicateValue
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(_ref2) {
      var value = _ref2.target.value;

      if (this.state.duplicateValue) {
        this.setState({
          duplicateValue: false
        });
      }

      this.props.onChange(this.props.value, value.trim());
    }
  }, {
    key: "renderBadge",
    value: function renderBadge() {
      return _react.default.createElement(_UITag.default, {
        className: "m-left-5"
      }, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "customerDataProperties.PropertyInputMultipleEmail.primaryEmailTag"
      }));
    }
  }, {
    key: "renderDropdownContent",
    value: function renderDropdownContent() {
      var _this$props2 = this.props,
          value = _this$props2.value,
          onDelete = _this$props2.onDelete,
          promoteToPrimary = _this$props2.promoteToPrimary;
      var isInputFocused = this.state.isInputFocused;

      if (isInputFocused) {
        return null;
      }

      return _react.default.createElement(_UIDropdown.default, {
        buttonUse: "transparent",
        buttonText: "Actions",
        disabled: this.props.propertyInputEmailDefaultProps.readOnly
      }, _react.default.createElement(_UIList.default, null, _react.default.createElement(_UIButton.default, {
        use: "transparent",
        size: "extra-small",
        onClick: this.partial(promoteToPrimary, value)
      }, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "customerDataProperties.PropertyInput.makePrimary"
      })), _react.default.createElement(_UIButton.default, {
        use: "transparent",
        size: "extra-small",
        onClick: this.partial(onDelete, value)
      }, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "customerDataProperties.PropertyInput.delete"
      }))));
    }
  }, {
    key: "renderDropdown",
    value: function renderDropdown() {
      if (!this.props.propertyInputEmailDefaultProps.readOnly) {
        return this.renderDropdownContent();
      }

      return _react.default.createElement(_UITooltip.default, {
        title: _react.default.createElement(_FormattedHTMLMessage.default, {
          message: "customerDataProperties.PropertyInputMultipleEmail.permissionsAlert.editContact"
        })
      }, this.renderDropdownContent());
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          draftEmails = _this$props3.draftEmails,
          onCancel = _this$props3.onCancel,
          onSave = _this$props3.onSave,
          propertyInputEmailDefaultProps = _this$props3.propertyInputEmailDefaultProps,
          resolver = _this$props3.resolver,
          value = _this$props3.value;
      var duplicateValue = this.state.duplicateValue;
      var draftValue = this.getDraftValue(value);
      var isNewEmail = draftEmails.get(value).get('isNewEmail');
      var isSaveDisabled = value === draftValue || !draftValue || !draftValue.length || !(0, _PropertyValidations.isValidEmail)(draftValue) || duplicateValue;
      var classes = (0, _classnames.default)({
        'p-top-5': this.getIsPrimaryEmail()
      }, {
        'p-top-3': !this.getIsPrimaryEmail()
      }, 'p-left-0');
      return _react.default.createElement(_UIGrid.default, null, _react.default.createElement(_UIGridItem.default, {
        size: {
          xs: 8
        },
        className: "p-left-0 p-right-0"
      }, _react.default.createElement(_UIEditableControls.default, {
        className: "m-bottom-1",
        onCancel: this.partial(onCancel, value),
        onOpenChange: this.handleOpenChange,
        onSave: this.partial(onSave, value),
        saveDisabled: isSaveDisabled,
        use: "flush"
      }, _react.default.createElement(_UIFormControl.default, null, _react.default.createElement(_PropertyInputEmailWrapper.default, (0, _extends2.default)({
        autoFocus: isNewEmail,
        className: "p-x-2",
        onChange: this.handleChange,
        onInvalidProperty: this.handleInvalidProperty,
        resolver: resolver,
        suppressAlerts: true,
        value: draftValue
      }, propertyInputEmailDefaultProps, {
        "data-selenium-test": this.props['data-selenium-test']
      }))))), _react.default.createElement(_UIGridItem.default, {
        size: {
          xs: 4
        },
        className: classes
      }, this.getIsPrimaryEmail() ? this.renderBadge() : this.renderDropdown()));
    }
  }]);
  return PropertyInputMultipleEmailInput;
}(_PureComponent2.default);

exports.default = PropertyInputMultipleEmailInput;
PropertyInputMultipleEmailInput.propTypes = propTypes;
module.exports = exports.default;